import React, { useRef, useState } from 'react';
import './Contact.css';
import { MdOutlineEmail } from 'react-icons/md';
import { AiOutlineLinkedin } from 'react-icons/ai';
import { FaWhatsapp } from 'react-icons/fa';
import emailjs from 'emailjs-com';
import Navbar from '../Navbar/nbar';


const Contact = () => {
  const form = useRef();
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setSending(true);
    emailjs.sendForm('service_2idz8kw', 'template_z0bju65', form.current, 'qSp_483cmAMmnfRWN')
      .then(() => { setSent(true); e.target.reset(); })
      .catch(() => {})
      .finally(() => setSending(false));
  };

  return (
    <section className="ct__section" id="contact">
      <Navbar/>
      <div className="ct__inner">
        <div className="ct__header">
          <span className="ct__tag">Get in Touch</span>
          <div className="ct__title">Let's Start a Conversation</div>
          <p className="ct__sub">Whether you're an individual exploring financial tools or a business seeking enterprise solutions — we'd love to hear from you.</p>
        </div>

        <div className="ct__grid">
          {/* LEFT — Contact cards */}
          <div className="ct__cards">
            <div className="ct__card">
              <div className="ct__card-icon"><MdOutlineEmail size={22} /></div>
              <div className="ct__card-body">
                <div className="ct__card-title">Email Us</div>
                <div className="ct__card-detail">admin@thesomfin.com</div>
                <div className="ct__card-detail ct__card-detail--sub">omprakash@thesomfin.com</div>
                <div className="ct__card-detail ct__card-detail--sub">souryadeepta@thesomfin.com</div>
              </div>
              <a href="mailto:admin@thesomfin.com" className="ct__card-link" target="_blank" rel="noopener noreferrer">Send Email →</a>
            </div>

            <div className="ct__card">
              <div className="ct__card-icon"><AiOutlineLinkedin size={22} /></div>
              <div className="ct__card-body">
                <div className="ct__card-title">LinkedIn</div>
                <div className="ct__card-detail">SOMFIN</div>
              </div>
              <a href="https://www.linkedin.com/company/somfin/" className="ct__card-link" target="_blank" rel="noopener noreferrer">Connect →</a>
            </div>

            <div className="ct__card">
              <div className="ct__card-icon"><FaWhatsapp size={22} /></div>
              <div className="ct__card-body">
                <div className="ct__card-title">WhatsApp</div>
                <div className="ct__card-detail">+91 (858) 301 1212</div>
              </div>
              <a href="https://api.whatsapp.com/send?phone=918583011212" className="ct__card-link" target="_blank" rel="noopener noreferrer">Message →</a>
            </div>

            {/* Address card */}
            <div className="ct__card ct__card--address">
              <div className="ct__card-icon">
                <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 10c0 6-9 13-9 13S3 16 3 10a9 9 0 0118 0z" /><circle cx="12" cy="10" r="3" />
                </svg>
              </div>
              <div className="ct__card-body">
                <div className="ct__card-title">Visit Us</div>
                <div className="ct__card-address">IITM Research Park, 1FA I Floor, Kanagam Road, TTTI Taramani, Chennai, Tamil Nadu — 600113</div>
              </div>
            </div>
          </div>

          {/* RIGHT — Form */}
          <div className="ct__form-wrap">
            {sent ? (
              <div className="ct__form-success">
                <div className="ct__form-success-icon">✓</div>
                <div className="ct__form-success-title">Message Sent</div>
                <p className="ct__muted">Thank you for reaching out. We'll get back to you within 24 hours.</p>
                <button className="ct__btn-outline" onClick={() => setSent(false)} type="button">Send Another Message</button>
              </div>
            ) : (
              <>
                <div className="ct__form-header">
                  <div className="ct__form-title">Send Us a Message</div>
                  <p className="ct__muted">Fill out the form and our team will respond promptly.</p>
                </div>
                <form ref={form} onSubmit={sendEmail} className="ct__form">
                  <div className="ct__field">
                    <label className="ct__field-label">Full Name</label>
                    <input type="text" name="name" placeholder="Your full name" required />
                  </div>
                  <div className="ct__field">
                    <label className="ct__field-label">Email Address</label>
                    <input type="email" name="email" placeholder="your@email.com" required />
                  </div>
                  <div className="ct__field">
                    <label className="ct__field-label">Message</label>
                    <textarea name="message" rows="5" placeholder="How can we help you?" required />
                  </div>
                  <button type="submit" className="ct__btn-primary" disabled={sending}>
                    {sending ? 'Sending...' : 'Send Message'} {!sending && <span>→</span>}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;